import src from "IMAGE";
export default { src, width: 640, height: 49, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/webp;base64,UklGRnIAAABXRUJQVlA4TGYAAAAvBwAAEM1VICICHggQAAAAAAAQQiAAAAAAAAAAAAAAAAAAAAAAAAAACAAAAAAAACAUAAAAgAgPBAgAAAAA4PwRCQAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAACAKDMmRLR7dgs="};
